var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZw = function SvgZw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 126"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#319208",
    d: "M0 0h252v126H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD200",
    d: "M0 18h252v90H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE2010",
    d: "M0 36h252v54H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 54h252v18H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m4.583 0 84 63-84 63H0V0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m0 0 84 63-84 63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE2010",
    d: "m46.161 66.045 18.273-12.934-21.029-3.055L34 31l-9.405 19.056-21.029 3.055 18.273 12.934-4.003 19.203L34 76l16.164 9.248z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC618",
    d: "M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282s18.898 3.3 20.274 3.458c-.9-.9-16.621-12.545-19.85-14.875s-4.129-3.388-4.129-3.388-2.911-5.24-3.917-6.776-2.858-3.705-5.293-3.705-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716-3.423 6.07-3.423 9.105c0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.212
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.635 55.109c1.976 4.305 2.47 4.588 7.411 6.282s18.898 3.3 20.274 3.458c-.9-.9-16.621-12.545-19.85-14.875s-4.129-3.388-4.129-3.388-2.911-5.24-3.917-6.776-2.858-3.705-5.293-3.705-3.917 1.429-4.623 3.97c-.388.106-2.47 1.376-2.4 2.682.6-.071 4.376-1.129 5.682 3.141s1.376 11.257.035 14.716-3.423 6.07-3.423 9.105c0 .423.282 1.27.988 1.27.247 1.341 2.223 10.904 2.223 10.904h28.161l4.473-17.292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.39 70.99s5.999-.353 7.623-.353c1.623 0 16.734.019 25.165 1.968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.508 70.871s-.601-.728-.213-2.175 4.623-5.188 4.623-10.481m-.776 12.422s-.494-2.364 4.905-4.376c1.518-.459 5.858-2.894 5.999-4.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.473 66.485s13.243.058 23.724 2.175m-20.404-3.755s4.551.156 5.292-.056 2.053-.762 2.575-2.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.49 64.959s2.434-1.265 2.911-2.911m-10.26 19.846s-1.041-7.216-1.253-11.257l2.717 2.594 2.875-2.514 2.472 2.638 2.858-2.425 2.471 2.778 2.83-2.407 2.252 2.618 2.822-2.041 3.355 3.189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.951 77.345c-10.081-1.444-23.57-1.35-23.57-1.35m-4.687-24.943s8.2-3.918 9.647-4.465"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    transform: "translate(16 36)scale(.21174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.487 177.086 13.018 11.852 11.762-11.762 11.896 12.266 12.846-11.358 11.827 12.43 13.339-11.013 10.897 12.728 13.27-10.145 13.947 12.319"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.425,
    cy: 154.584,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.237,
    cy: 156.047,
    r: 5.167
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.05,
    cy: 16.5,
    r: 4
  }))));
};
export default SvgZw;